import { FC, useCallback, useState } from "react";
import { Column, Row } from "../../components/containers";
import DateBaseActivities from "../../components/date-base-activities";
import { AlignItems, JustifyContent } from "../../components/containers/types";
import Users from "./users";
import { useResize } from "../../hooks";
import AddTag from "./add-tag";
import DashboardSettings from "./dashboard-settings";

const AdminPanel: FC = () => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  useResize(
    useCallback(() => {
      if (window.innerWidth > width) {
        window.location.reload();
      }
      setWidth(window.innerWidth);
    }, [width])
  );

  return (
    <Column style={{ overflowY: "auto", overflowX: "hidden" }}>
      <Row
        justifyContent={JustifyContent.Between}
        alignItems={AlignItems.Start}
        style={{ width: "100%", minHeight: 200, margin: "1rem" }}
        gap={50}
        className="admin-panel-con"
      >
        <DateBaseActivities />
        <Users />
      </Row>

      <AddTag />

      <DashboardSettings />
    </Column>
  );
};

export default AdminPanel;
